export enum InteractionName {
  BannerComponentLoad = 'banner-component-load', // TODO: remove after Stores GA lazy with appLoadStarted
  BannerRender = 'banner-render',
  FetchBnplMethods = 'fetch-bnpl-methods',
  FetchBannerSettings = 'fetch-banner-settings',
}
